/* global _ */

ADV.entities = Object.assign(ADV.entities || {}, {
  getCurrentClientId() {
    return _.get(ADV.store.getState(), 'AdviserArea.currentClient.Id');
  },

  getCurrentClient() {
    return this.getClient(_.get(ADV.store.getState(), 'AdviserArea.currentClient.Id'));
  },

  getCurrentPage() {
    return _.get(ADV.store.getState(), 'Router.currentRoute.controller');
  },

  getClient() {
    return _.get(ADV.store.getState(), 'AdviserArea.currentClient');
  },

  getSampleClients() {
    return _.get(ADV.store.getState(), 'AdviserArea.sample_clients', ADV.data.sample_clients);
  },

  getUserObject() {
    if (ADV.util.env('isAdviserArea')) {
      return _.get(ADV.store.getState(), 'AdviserArea.currentClient', {});
    }

    return ADV.data.user;
  },

  isOptedIn(name) {
    const currentClient = ADV.util.getCurrentClient(ADV.data);

    return !(currentClient.OptOuts || []).includes(name);
  },
});

export default ADV.entities;
